/**
 * Erro de transporte HTTP, preservando a causa original.
 *
 * O `AxiosHttpClient` fazia `new Error(error.message)` no catch, o que **apagava `code` e
 * `response`** do erro do axios. Duas consequências reais:
 *
 * 1. `isTransientNetworkError` deixava de reconhecer timeouts (`ECONNABORTED` /
 *    "timeout of 30000ms exceeded" não casavam com nenhum substring), então só `ERR_NETWORK`
 *    sobrevivia — e timeout é exatamente um dos casos que vale retentar.
 * 2. `status` ficava sempre `undefined` em falha, vazando em log como `HTTP undefined`.
 *
 * A classe estende `Error`, então todo consumidor de `response.error` (`.message`,
 * `Result.fail(response.error)`, logger) continua funcionando sem alteração.
 */
export class HttpTransportError extends Error {
  /** Código do axios: `ERR_NETWORK`, `ECONNABORTED`, `ERR_CANCELED`, `ETIMEDOUT`... */
  readonly code?: string
  /** Status HTTP, quando o erro carregava resposta (raro: `validateStatus` aceita tudo). */
  readonly httpStatus?: number
  /** Erro original do axios, intacto, para inspeção e telemetria. */
  readonly originalError?: unknown

  constructor(message: string, options: { code?: string; httpStatus?: number; originalError?: unknown } = {}) {
    super(message)
    this.name = 'HttpTransportError'
    this.code = options.code
    this.httpStatus = options.httpStatus
    this.originalError = options.originalError
  }
}
